import React from 'react';
import axios from "../../containers/api";
import { Alert, Button, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, CustomInput } from "reactstrap";
import {showCatchError, toEnglishNumbers} from "../../helpers/Utils";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import NewUserModal from "./NewUserModal";

class NewTransportationCompany extends React.Component {
    constructor(props) {
        super(props);
        this.fileUploader = React.createRef();
        this.state = {
            isModal: this.props && this.props.isModal,
            ProvinceList: [],
            TransportationCompanyName: "",
            Email: "",
            NationalId: "",
            Address: "",
            PostalCode: "",
            Tell: "",
            AnnouncementLimitMinutes: 0,
            Mobile: "",
            Province: null,
            CityList: [],
            City: null,
            showNewMemberModal: false,
            newMemberUsername: null,
            newMemberPassword: null,
            errors: [],
            file: null, //uploaded picture
            IsBillAndDraft: false,
        }
        //console.log('test')
    }

    componentDidMount() {
        //if (!this.state.isModal) {
        //   // this.CheckMemberTypeIsAdmin();
        //   this.loadProvinces();
        //}
    }

    //componentWillReceiveProps(nextProps) {
    //    if (this.props !== nextProps) {
    //        this.setState({ProvinceList: this.props.ProvinceList});
    //    }
    //}
    componentWillMount() {
        this.loadProvinces();
    }

    CheckMemberTypeIsAdmin = () => {
        this.props.showSpinner();
        axios.get('api/ClientApi/CheckMemberTypeIsAdmin')
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data) {
                    this.loadProvinces();
                } else {
                    this.props.history.push('/error404')
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };
    loadProvinces = () => {
        this.props.showSpinner();
        axios.get('api/v1/provinces/GetAll')
            .then((res) => {
                this.props.hideSpinner();
                this.setState({ProvinceList: res.data.data});
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    loadCities = (id) => {
        this.props.showSpinner();
        axios.get('api/v1/cities/GetCityByProvinceId/' + id)
            .then((res) => {
                this.props.hideSpinner();
                this.setState({CityList: res.data.data});
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    validateInputData = () => {
        this.props.closeSweetAlert();
        let error = [];
        if (this.state.TransportationCompanyName.length ===0) {
            error.push("وارد كردن نام شركت حمل و نقل الزامی میباشد");
        }
        if (this.state.NationalId.length < 10 ) {
            error.push("کد ملی نباید کمتر از ۱۰ حرف باشد.");
        }
        if (this.state.Tell.length === 0 && this.state.Mobile.length === 0) {
            error.push("وارد كردن تلفن يا موبايل شركت حمل و نقل الزامی میباشد.");
        }
        if (this.state.Address.length===0) {
            error.push("وارد كردن آدرس شركت حمل و نقل الزامی میباشد.");
        }
        if (this.state.City === null || this.state.City === undefined) {
            error.push("انتخاب شهر الزامی میباشد.");
        }
        if (this.state.file === null) {
            error.push("لطفا فایل مورد نظر را انتخاب کنید");
        }
        this.setState({errors: error});
        if (error.length === 0) {
            this.AddTransportationCompany();
        } else {
            this.props.showAlert("لطفا تمامی اطلاعات درخواست شده را به درستی وارد کنید!", "error");
        }
    };

    AddTransportationCompany= () => {
        let addModel = new FormData();
        addModel.set('TransportationCompanyName', toEnglishNumbers(this.state.TransportationCompanyName));
        addModel.set('Email', toEnglishNumbers(this.state.Email));
        addModel.set('NationalId', toEnglishNumbers(this.state.NationalId));
        addModel.set('Address', toEnglishNumbers(this.state.Address));
        addModel.set('PostalCode', toEnglishNumbers(this.state.PostalCode));
        addModel.set('IsBillAndDraft', toEnglishNumbers(this.state.IsBillAndDraft));
        addModel.set('Tell', toEnglishNumbers(this.state.Tell));
        addModel.set('AnnouncementLimitMinutes', toEnglishNumbers(this.state.AnnouncementLimitMinutes));
        addModel.set('Mobile', toEnglishNumbers(this.state.Mobile));
        addModel.set('CityId', this.state.City !== null ? this.state.City.cityId : null);
        addModel.append('File', this.state.file); 
        this.props.showSpinner();
        //axios.post('/api/v1/transportation-companies/AddTransportationCompany', addModel)
        //    .then((res) => {
        axios.post('/api/v1/transportation-companies/AddTransportationCompany', addModel, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((res) => {
                this.props.hideSpinner();
               /* if (res.status === 200) {*/
                    //this.setState({
                    //    newMemberUsername: res.data.data.userName,
                    //    newMemberPassword: res.data.data.password,
                    //    showNewMemberModal: true
            //});
            this.props.showAlert(res.data.message, "success");
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    
    selectHandleChange = (event, value, name) => {
        this.setState({ [name]: value },
            () => {
                if (name === "Province") {
                    if (value !== undefined && value !== null) {
                        this.setState({
                            City: null
                        }, () => this.loadCities(value.provinceId));
                    }
                    else {
                        this.setState({
                            City: null, CityList: []
                        })
                    }
                }

            });
    };
    render() {
        return (
            <div className="d-flex flex-column w-100">
                <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap w-100 mt-5">
                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>نام شرکت حمل و نقل</Label>
                        <Input value={this.state.TransportationCompanyName} maxLength={300}
                               onChange={(e) => this.setState({ TransportationCompanyName: e.target.value })}/>
                    </FormGroup>

                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>موبایل</Label>
                        <Input value={this.state.Mobile} maxLength={11}
                               onChange={(e) => this.setState({ Mobile: e.target.value })}/>
                    </FormGroup>

                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>کد ملی</Label>
                        <Input value={this.state.NationalId} maxLength={11}
                               onChange={(e) => this.setState({ NationalId: e.target.value })}/>
                    </FormGroup>

                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>آدرس</Label>
                        <Input value={this.state.Address}
                               onChange={(e) => this.setState({ Address: e.target.value })}/>
                    </FormGroup>

                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>کد پستی</Label>
                        <Input value={this.state.PostalCode} maxLength={10}
                               onChange={(e) => this.setState({ PostalCode: e.target.value })}/>
                    </FormGroup>

                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>تلفن</Label>
                        <Input value={this.state.Tell} maxLength={100}
                               onChange={(e) => this.setState({ Tell: e.target.value })}/>
                    </FormGroup>

                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>ایمیل</Label>
                        <Input value={this.state.Email} maxLength={100}
                               onChange={(e) => this.setState({ Email: e.target.value })}/>
                    </FormGroup>

                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>استان</Label>
                        <Autocomplete
                            clearText={"حذف"}
                            closeText={"بستن"}
                            noOptionsText={"در حال دریافت اطلاعات.."}
                            openText={"باز کردن"}
                            className="react-select__control"
                            id="Province"
                            options={this.state.ProvinceList}
                            getOptionLabel={(option) => option.provinceName}
                            value={this.state.Province}
                            onChange={(e, v) => this.selectHandleChange(e, v, "Province")}
                            renderInput={(params) => (<TextField{...params} variant="standard"/>)}
                        />
                    </FormGroup>

                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>شهر</Label>
                        <Autocomplete
                            clearText={"حذف"}
                            closeText={"بستن"}
                            noOptionsText={"در حال دریافت اطلاعات.."}
                            openText={"باز کردن"}
                            className="react-select__control"
                            id="City"
                            options={this.state.CityList}
                            getOptionLabel={(option) => option.cityName}
                            value={this.state.City}
                            onChange={(e, v) => this.selectHandleChange(e, v, "City")}
                            renderInput={(params) => (<TextField{...params} variant="standard"/>)}
                        />
                    </FormGroup>

                
                    <FormGroup className="w-md-30 w-100 px-1"> 
                        <Label>زمان محدودیت اعلام بار</Label>
                        <Input
                            value={this.state.AnnouncementLimitMinutes}
                            maxLength={3}
                            onChange={(e) => {
                                let value = e.target.value.replace(/[^0-9۰-۹]/g, ""); // فقط عدد انگلیسی و فارسی 

                                // حذف صفرهای اضافی اول عدد
                                if (value.length > 1) {
                                    value = value.replace(/^0+/, "");
                                }

                                // اگر کاربر همه چیز رو پاک کرد، مقدار رو صفر بذار
                                if (value === "") value = "0";

                                this.setState({ AnnouncementLimitMinutes: value });
                            }}
                        />
                    </FormGroup>
                    <FormGroup className="w-md-30 w-100 px-1">
                        
                            <CustomInput
                            checked={this.state.IsBillAndDraft}
                            onChange={() => this.setState({ IsBillAndDraft: !this.state.IsBillAndDraft })}
                                type="checkbox"
                            id="IsBillAndDraft"
                            label="دسترسی حواله یا بارنامه"
                            />
                         
                    </FormGroup>
                    <FormGroup className="w-md-30 w-100 px-1">
                    </FormGroup>
                </div>
                <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap w-100 mt-5">
                    <FormGroup className="w-md-25 w-100 mx-1">
                        <label className="form-title">
                            تصویر</label>

                        <input
                            style={{ cursor: "cell" }}
                            className="input" value={this.state.file !== null ? this.state.file.name : "لطفا یک فایل انتخاب کنید"}
                            onClick={() => this.fileUploader.current.click()} />
                        <input
                            ref={this.fileUploader}
                            style={{ display: "none" }} type="file"
                            onChange={(e) => {
                                this.setState({ file: e.target.files[0] });
                            }}
                        />
                    </FormGroup>
                </div>
                {this.state.errors.length === 0 ?
                    null
                    :
                    <div>
                        {(this.state.errors.map((error, i) => {
                            return (
                                <Alert color="danger" key={i}>{error}</Alert>
                            )
                        }))}
                    </div>
                }

                <div className="d-flex flex-md-row flex-column justify-content-center align-items-end flex-wrap w-100 mt-5">
                    <FormGroup className="text-center">
                        <Button color="primary" className="btn-lg mx-2"
                                onClick={() => this.props.showSweetAlert("آیا از صحت اطلاعات وارد شده اطمینان دارید؟", "", "warning", this.validateInputData)}>
                            ثبت
                        </Button>
                    </FormGroup>
                </div>

                <Modal isOpen={this.state.showNewMemberModal} toggle={() => this.setState({showNewMemberModal: false, newMemberUsername: null, newMemberPassword: null})}>
                    <ModalHeader toggle={() => this.setState({showNewMemberModal: false, newMemberUsername: null, newMemberPassword: null})}>
                        اطلاعات کاربری
                    </ModalHeader>
                    <ModalBody>
                        <NewUserModal
                            newMemberUsername={this.state.newMemberUsername}
                            newMemberPassword={this.state.newMemberPassword}
                        />
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

export default NewTransportationCompany;